import { render, staticRenderFns } from "./CrmCommon.vue?vue&type=template&id=2bee7eec&"
import script from "./CrmCommon.vue?vue&type=script&lang=js&"
export * from "./CrmCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports